// extracted by mini-css-extract-plugin
module.exports = {"twoImg":"twoImg-X9tH_5Ae","twoPicItem":"twoPicItem-3K6aqgJS","picBox":"picBox-vakEZANc","videoIcon":"videoIcon-li8fcDJr","mark":"mark-DxUSpQXi","txt":"txt-78FtAzIu"};